import { MatDateFormats } from '@angular/material/core'

export const dateFormats = {
  dateTime: 'DD/MM/YYYY HH:mm',
  time: 'HH',
  second: 'HH:mm:ss',
  fullTime: 'HH:mm',
  date: 'DD/MM/YYYY',
  inputDate: 'YYYY-MM-DD',
  dateFullTime: 'YYYY-MM-DD HH:mm:ss',
  dateTimeFull: 'DD/MM/YYYY HH:mm:ss',
}

export const LIN_MOMENT_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
